import React, { useEffect, useState } from 'react';
import { Checkbox, Avatar, Card, Tag, Image } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import LookupDisplayCard from './LookupDisplayCard';
import ApiService from '../Components/apiService';
import { BASE_URL, DateFormat } from '../Components/Constant';
import { colors, getUniqueColor, useHoverVisibility } from '../Components/Utility';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { LookupCell } from './LookupCell';



const DisplayField = ({ type, form, name, field, record, layouts }) => {

    const [currency, setCurrency] = useState('');
    const defaultCurrency = useSelector(state => state.data.orgItem);

    const fetchOrgSetupDetails = async () => {
        setCurrency(defaultCurrency?.currency);
    };

    useEffect(() => {
        fetchOrgSetupDetails();

    }, []);

    const {
        isHovered,
        isVisible,
        handleMouseEnter,
        handleMouseLeave,
        handleContentMouseEnter,
        handleContentMouseLeave,
    } = useHoverVisibility();


    useEffect(() => {
        // Logic to handle changes in record data
        if (record) {

        }
    }, [record]);

    const fieldValue = form.getFieldValue(name);

    const displayField = field?.lookup_config?.display_fields;
    const renderField = () => {
        switch (type) {
            case 'boolean':
                return <Checkbox checked={fieldValue} disabled />;
            case 'currency':
                return `${currency || '$'}${fieldValue !== undefined && fieldValue !== null ? parseFloat(fieldValue).toFixed(2) : ''}`;
            case 'string':
                return fieldValue || '';
            case 'percentage':
                return `${fieldValue !== undefined && fieldValue !== null ? parseFloat(fieldValue)?.toFixed(2) : ''}%`;
            case 'integer':
                return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
            case 'decimal':
                return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
            case 'email':
                return fieldValue ? <a href={`mailto:${fieldValue}`}>{fieldValue}</a> : '';
            case 'url':
                return fieldValue ? (
                    <a
                        href={fieldValue.startsWith('http') ? fieldValue : `http://${fieldValue}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {fieldValue}
                    </a>
                ) : '';
            case 'address':
                return fieldValue
                    ? [fieldValue.street, fieldValue.city, fieldValue.state, fieldValue.postal_code, fieldValue.country]
                        .filter(Boolean)
                        .join(', ')
                    : '';

            case 'lookup':
               

                const lookupId = fieldValue || {};
                const ob = field?.parent_object_name;
                return(
                <LookupCell lookupId={lookupId} field={field} ob={ob} />
                );

            case 'image':
                return fieldValue ? (

                    <Image
                        src={fieldValue}
                        width={field?.image_config?.width} // Fallback to 100 if undefined
                        style={{
                            width: `${field?.image_config?.width || 100}px`,
                            height: `${field?.image_config?.height || 'auto'}px`,
                            maxWidth: `${field?.image_config?.width || 100}px`,
                            maxHeight: `${field?.image_config?.height || 'auto'}px`,
                            objectFit: 'contain' // Ensure the image fits within the defined space
                        }} // Ensure height is applied
                    />
                ) : (
                    ''
                );
            case 'phone':
                return fieldValue ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PhoneOutlined style={{ marginRight: 8 }} />
                        {fieldValue || ''}
                    </div>
                ) : '';
            case 'multiselect':
                return Array.isArray(fieldValue) ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
                        {fieldValue.map((value, index) => (
                            <Tag key={index}
                                color={getUniqueColor(index)}
                                style={{
                                    fontSize: '12px', // Increase font size
                                    padding: '4px 10px', // Adjust padding for larger size
                                    borderRadius: '8px', // Add rounded corners for better aesthetics
                                    lineHeight: '1.5', // Adjust line height for better spacing
                                }}
                            >
                                {value}
                            </Tag>
                        ))}
                    </div>
                ) : (
                    fieldValue || ''
                );

            case 'richtext':
                return (
                    <div
                    className="rendered-message"
                    style={{
                        position: "relative",
                        width: "auto",
                    }}
                    >
                    <div
                        className="rendered-message"
                        style={{
                        padding: '5px',
                        fontSize: '12px',
                        minHeight: 'auto',
                        color: '#555',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        borderRadius: '4px',
                        maxWidth: '100%',
                        backgroundColor: '#fff',
                        position: "relative",
                        zIndex: 0,
                        pointerEvents: 'auto', // allows text interaction
                        }}
                        dangerouslySetInnerHTML={{ __html: fieldValue }}
                    />
                    </div>
                );
                
            default:
                return fieldValue || '';
        }
    };

    return (
        <div
            style={{
                flex: 1,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxWidth: '100%',
                background: 'transparent',
                border: 'none',
                padding: 0,
                margin: 0,
                overflowWrap: 'break-word',
                fontSize: '14px',
                fontWeight: 500,
            }}
        >
            {renderField()}
        </div>
    );
};

export default DisplayField;
